import { AsHeadline } from '#components/HeadlineFont.tsx'

export const Support = () => (
	<>
		<h2>Support</h2>
		<p>
			Premium support is available via e-mail at{' '}
			<a href="mailto:premium@teamstatus.space">premium@teamstatus.space</a>.
		</p>
		<p>
			You are invited to submit ideas for improvement in the{' '}
			<a
				href="/project/%24teamstatus%23feedback"
				target="_blank"
				rel="noreferrer noopener"
			>
				<AsHeadline>$teamstatus#feedback</AsHeadline>
			</a>{' '}
			project.
		</p>
	</>
)
